import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AdminDetails } from "@/types/reducer-states";

interface AuthState {
  adminDetails: AdminDetails | null;
  whiteLabelCode: string | null;
  errorMessage: string | null;

  setAdminDetails: (details: AdminDetails | null) => void;
  setWhiteLabelCode: (code: string | null) => void;
  setErrorMessage: (message: string | null) => void;
  clearErrorMessage: () => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      adminDetails: null,
      whiteLabelCode: null,
      errorMessage: null,

      setAdminDetails: (details) => set({ adminDetails: details }),

      setWhiteLabelCode: (code) => set({ whiteLabelCode: code }),

      setErrorMessage: (message) => set({ errorMessage: message }),

      clearErrorMessage: () => set({ errorMessage: null }),

      clearAuth: () =>
        set({
          adminDetails: null,
          whiteLabelCode: null,
          errorMessage: null,
        }),
    }),
    {
      name: "auth-store",
      partialize: (state) => ({
        // Only persist admin details - token is handled separately
        adminDetails: state.adminDetails,
        whiteLabelCode: state.whiteLabelCode,
      }),
    }
  )
);

export const useAdminDetails = () =>
  useAuthStore((state) => state.adminDetails);
export const useWhiteLabelCode = () =>
  useAuthStore((state) => state.whiteLabelCode);
export const useErrorMessage = () =>
  useAuthStore((state) => state.errorMessage);

export const useWhiteLabelId = () => {
  const adminDetails = useAuthStore((state) => state.adminDetails);
  return adminDetails?.whiteLabelId ?? null;
};

export const useIsSuperAdmin = () => {
  const adminDetails = useAuthStore((state) => state.adminDetails);
  return (
    adminDetails != null &&
    adminDetails.cityId == null &&
    adminDetails.whiteLabelId == null
  );
};
